import React from "react";
import { Quote } from "lucide-react";

const items = [
  {
    quote: "Reliable daily water delivery for our office. Never missed a day.",
    name: "Anisha Reddy",
    role: "Office Admin, Indiranagar",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=faces&fit=crop&w=200&h=200",
  },
  {
    quote: "Affordable and fast service across Bengaluru — exactly what we needed.",
    name: "Sujan Iyer",
    role: "Homeowner, Whitefield",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=faces&fit=crop&w=200&h=200",
  },
  {
    quote: "Ordering through the app is simple and convenient. Reorder in two taps.",
    name: "Priya Nair",
    role: "Cafe Owner, Koramangala",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=faces&fit=crop&w=200&h=200",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow">Trusted Daily</div>
            <h2 className="serif h-display mt-4 text-4xl sm:text-5xl lg:text-6xl text-[#0b1d2a]">
              Water we deliver. <br />
              <span className="italic text-[#0369a1]">Words they share.</span>
            </h2>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-tilt rounded-3xl bg-[#f6fbff] border border-sky-100 p-7 relative"
            >
              <Quote className="text-[#0ea5e9]/40" size={28} />
              <blockquote className="mt-4 text-[#0b1d2a] serif text-xl leading-snug">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t border-sky-100">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-white" />
                <div>
                  <div className="text-sm font-semibold text-[#0b1d2a]">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
